import { Link } from "react-router-dom";
import Logo from "./Logo";

const CONTACT_EMAIL = "hola@matronaia.com";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-[#e8dcc8]/60 bg-[#fbf8f5]"
        >
            <div className="max-w-6xl mx-auto px-6 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
                <div>
                    <Logo size={44} />
                    <p className="mt-5 text-[0.92rem] leading-relaxed text-[#5c5450] max-w-xs">
                        Acompañamiento basado en evidencia, lleno de
                        humanidad, durante el embarazo, el parto, el posparto,
                        la lactancia y la crianza temprana.
                    </p>
                </div>

                <div>
                    <p className="eyebrow mb-4">Navegación</p>
                    <ul className="space-y-2.5 text-[0.95rem] text-[#5c5450]">
                        <li>
                            <Link
                                to="/"
                                data-testid="footer-link-home"
                                className="hover:text-[#b7677a] transition-colors"
                            >
                                Inicio
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/aviso-medico"
                                data-testid="footer-link-medical"
                                className="hover:text-[#b7677a] transition-colors"
                            >
                                Aviso Médico
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/politica-privacidad"
                                data-testid="footer-link-privacy"
                                className="hover:text-[#b7677a] transition-colors"
                            >
                                Política de Privacidad
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/terminos-de-uso"
                                data-testid="footer-link-terms"
                                className="hover:text-[#b7677a] transition-colors"
                            >
                                Términos de Uso
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/contacto"
                                data-testid="footer-link-contact"
                                className="hover:text-[#b7677a] transition-colors"
                            >
                                Contacto
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/eliminar-cuenta"
                                data-testid="footer-link-delete-account"
                                className="hover:text-[#b7677a] transition-colors"
                            >
                                Eliminar cuenta y datos
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <p className="eyebrow mb-4">Contacto</p>
                    <a
                        href={`mailto:${CONTACT_EMAIL}`}
                        data-testid="footer-email"
                        className="text-[#b7677a] hover:text-[#9a4f63] transition-colors text-[0.95rem] break-all"
                    >
                        {CONTACT_EMAIL}
                    </a>
                    <p className="mt-4 text-[0.85rem] text-[#8a807b] leading-relaxed">
                        Para cualquier duda relacionada con privacidad o
                        funcionamiento de la app.
                    </p>
                </div>
            </div>

            <div className="border-t border-[#e8dcc8]/60">
                <div className="max-w-6xl mx-auto px-6 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[0.82rem] text-[#8a807b]">
                    <p data-testid="footer-copyright">© {year} Matrona IA</p>
                    <p className="italic font-serif text-[0.95rem] text-[#5c5450]">
                        Acompañar · Informar · Orientar
                    </p>
                </div>
            </div>
        </footer>
    );
}
